import { HeaderTitle } from './header-title.model';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HeaderTitleService {

  prodServeId:any=1;

    updatePageTitle = new BehaviorSubject<HeaderTitle>(new HeaderTitle([]));

    setPageTitle(headerTitle: HeaderTitle) {
      this.updatePageTitle.next(headerTitle);
    }

    getPageTitle() {
      return this.updatePageTitle.asObservable();
    }

}
